import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import { css } from "@emotion/core";
import Header from "../../components/Header";
import FilterTab from "./components/FilterTab";
import Firebase from "../../firebasehelper";
import AddOfferModal from "../../components/AddOfferModal";

import LiveIcon from "../../assets/media/icons/live.svg";
import InactiveIcon from "../../assets/media/icons/inactive.svg";

import "./index.css";

const override = css`
  position: absolute;
  top: 48%;
  left: 48%;
  radius: 2px;
  height: 15px;
  width: 5px;
  display: block;
  margin: 0 auto;
  border-color: grey;
`;
const filter_array = (array) => {
  let arr = [];
  console.log("array", array);
  array.forEach((item, index) => {
    arr[item.id] = {
      ...item,
      original: index,
    };
  });
  return arr;
};
class Offers extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      offers: [],
      loading: true,
      tag: "",
      deactive_arr: [],
    };
  }
  componentDidMount() {
    if (!this.props.location.state && this.props.location.state.role !== 0) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
    }
    Firebase.getAllOffers((res) => {
      this.setState({ loading: false, count: res.length });
      let offers = filter_array(res);
      this.setState({ offers, max: offers.length });
    });
    Firebase.getAllDeactiveOffers((res) => {
      let deactive_arr = [];
      if (res) deactive_arr = res;
      this.setState({ deactive_arr });
    });
  }
  filter_View = (tag) => {
    console.log("tag", tag);
    if (tag === "all") this.setState({ tag: "" });
    else this.setState({ tag });
  };
  toggleActive = (id) => {
    let { deactive_arr } = this.state;
    deactive_arr[id] = !deactive_arr[id];
    Firebase.updateDeactiveOffers(deactive_arr);
  };
  addOffer = (
    provider,
    membershipBenefit,
    info,
    logo_img,
    bg_img,
    category,
    brandHex,
    top10,
    offerRedemptionType
  ) => {
    const { max, count } = this.state;
    console.log("offer id", max);
    console.log("offer number", count);
    this.setState({ loading: true });
    Firebase.addOfferImage("personal", provider, logo_img, bg_img).then(
      (res) => {
        console.log("image res", res);
        const offer = {
          dealHeroImage: res.background,
          name: provider,
          membershipBenefit,
          info,
          logo: res.logo,
          id: max,
          category,
          brandHex,
          top10,
          offerRedemptionType,
        };
        Firebase.addSuperOffer(count, offer);
        this.setState({ loading: false });
      }
    );
  };

  onEdit = (event) => {
    event.stopPropagation();
  };

  updateOffer =
    (id) =>
    (
      provider,
      membershipBenefit,
      info,
      logo_img,
      bg_img,
      category,
      brandHex,
      top10,
      offerRedemptionType
    ) => {
      const { offers } = this.state;
      const index = offers.findIndex((item) => item && item.id === id);
      if (index < 0) {
        return;
      }

      const dbIndex = offers[index].original;

      if (logo_img) {
        Firebase.addOfferLogo("personal", provider, logo_img).then((logoUrl) =>
          Firebase.updateSuperOffer(dbIndex, { logo: logoUrl })
        );
      }

      if (bg_img) {
        Firebase.addOfferBackground("personal", provider, bg_img).then(
          (bgUrl) =>
            Firebase.updateSuperOffer(dbIndex, { dealHeroImage: bgUrl })
        );
      }

      Firebase.updateSuperOffer(dbIndex, {
        name: provider,
        membershipBenefit,
        info,
        category,
        brandHex,
        top10,
        offerRedemptionType,
      });
    };
  render() {
    const { offers, logo, brand, loading, tag, deactive_arr } = this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;
    return (
      <div id="page-container">
        <Header username={username} role={role} logo={logo} brand={brand} />
        <main id="main-container">
          <div className="content">
            {loading && <i className="fa fa-4x fa-sync fa-spin text-muted" />}
            {!loading && <FilterTab filter_View={this.filter_View} />}
            {!loading && (
              <div className="tiles">
                {offers.map((item, index) => {
                  if (item.category.includes(tag))
                    return (
                      <React.Fragment key={index}>
                        <div
                          id={index}
                          className={`deal ${
                            deactive_arr[item.id] ? "deactive" : "activate"
                          }`}
                          style={{
                            backgroundImage: `url(${item.dealHeroImage})`,
                          }}
                          onClick={() => {
                            this.toggleActive(item.id);
                          }}
                        >
                          <div className="deal-caption">
                            <b>{item.name}</b>
                            <span>
                              {item.info && item.info.tokenPercentage
                                ? `${item.info.tokenPercentage}%`
                                : item.membershipBenefit}
                            </span>
                          </div>
                          <div className="status-container">
                            <div
                              className={classNames("status", {
                                inactive: deactive_arr[item.id],
                              })}
                            >
                              <img
                                src={
                                  deactive_arr[item.id]
                                    ? InactiveIcon
                                    : LiveIcon
                                }
                                alt="icon"
                              />
                              {deactive_arr[item.id] ? "INACTIVE" : "LIVE"}
                            </div>
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-toggle="modal"
                              data-target={`#add_offer_${item.id}`}
                              onClick={this.onEdit}
                            >
                              Edit
                            </button>
                          </div>
                          <div
                            className="deal-logo"
                            style={{ backgroundImage: `url(${item.logo})` }}
                          ></div>
                        </div>
                        <AddOfferModal
                          id={item.id}
                          offers={offers}
                          addOffer={this.updateOffer(item.id)}
                          initialValue={item}
                        />
                      </React.Fragment>
                    );
                })}
                <button
                  type="button"
                  className="btn btn-secondary add_btn"
                  data-toggle="modal"
                  data-target="#add_offer"
                >
                  Add New Offer
                </button>
              </div>
            )}
          </div>
          <AddOfferModal offers={offers} addOffer={this.addOffer} />
        </main>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapActionToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapActionToProps)(Offers);



// WEBPACK FOOTER //
// ./src/screens/super_offers/index.js